<script>
    import {
        getFormatDateAndTime,
        getText,
    } from "../../../Utils/utilFunctions.svelte";

    export let exceptionData = {};

    let isShowInfo = true;

    // HELPER FUNCTIONS
    const _toggleShowHideDetails = () => (isShowInfo = !isShowInfo);
</script>

<div
    class={`transition flex flex-col w-full lg:flex-row ${
        isShowInfo ? "" : "max-h-[50px]"
    }`}
>
    <div
        class="flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex justify-between pr-4 text-white cursor-pointer bg-gradient-to-b from-bg-primary to-bg-secondary"
            on:click|preventDefault={_toggleShowHideDetails}
        >
            <p class="font-bold px-2 py-4">Basic Information</p>
        </div>

        <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
            <div class="flex flex-col flex-1 gap-y-4 h-full">
                <div class="flex flex-row gap-x-2">
                    <p class="title">ID:</p>
                    <p class="content">
                        {getText(exceptionData.id)}
                    </p>
                </div>

                <div class="flex flex-row gap-x-2">
                    <p class="title">Create Date:</p>
                    <p class="content">
                        {getFormatDateAndTime(exceptionData.createdDate)}
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .title {
        width: 150px;
    }

    .content {
        width: calc(100% - 150px);
    }

    .transition {
        transition: 0.5s linear;
    }
</style>
